// extracted by mini-css-extract-plugin
module.exports = {"Index":"express_Index__2uzPk","Index__BooksArea":"express_Index__BooksArea__DUgJv","Index__BooksContent":"express_Index__BooksContent__3-e-r"};